/**
 * Utility function to combine two extents into a single extent
 * that encompasses both areas.
 */
export interface Extent {
  minx: number;
  miny: number;
  maxx: number;
  maxy: number;
}

/**
 * Combines two extents by taking the outer bounds of both.
 * Returns null if either extent is null/undefined.
 */
export function combineExtents(
  extent1: Extent | null | undefined,
  extent2: Extent | null | undefined
): Extent | null {
  if (!extent1 || !extent2) {
    return null;
  }

  return {
    minx: Math.min(extent1.minx, extent2.minx),
    miny: Math.min(extent1.miny, extent2.miny),
    maxx: Math.max(extent1.maxx, extent2.maxx),
    maxy: Math.max(extent1.maxy, extent2.maxy)
  };
}
